/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecreateStockups201ResponseAllOfData } from './RecreateStockups201ResponseAllOfData';
import {
    RecreateStockups201ResponseAllOfDataFromJSON,
    RecreateStockups201ResponseAllOfDataFromJSONTyped,
    RecreateStockups201ResponseAllOfDataToJSON,
} from './RecreateStockups201ResponseAllOfData';

/**
 * 
 * @export
 * @interface RecreateStockups201Response
 */
export interface RecreateStockups201Response {
    /**
     * 
     * @type {RecreateStockups201ResponseAllOfData}
     * @memberof RecreateStockups201Response
     */
    data: RecreateStockups201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof RecreateStockups201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the RecreateStockups201Response interface.
 */
export function instanceOfRecreateStockups201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function RecreateStockups201ResponseFromJSON(json: any): RecreateStockups201Response {
    return RecreateStockups201ResponseFromJSONTyped(json, false);
}

export function RecreateStockups201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecreateStockups201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': RecreateStockups201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function RecreateStockups201ResponseToJSON(value?: RecreateStockups201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': RecreateStockups201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

